import { SelectOption } from '@navstation-portal/shared/data-model/common';

export const MAX_CARGOES = 8;

export const CRANE_OPTIONS: SelectOption[] = [
  { name: '1', code: 1 },
  { name: '2', code: 2 },
  { name: '3', code: 3 },
  { name: '4', code: 4 },
] as const;

export const CARGO_GRADE_OPTIONS: SelectOption[] = [
  { code: 75, name: 'ACCOMMODATION UNITS' },
  { code: 52, name: 'AGGREGATE' },
  { code: 105, name: 'AGRI-PRODS' },
  { code: 37, name: 'AGRICULTURAL PRODUCTS' },
  { code: 3, name: 'ALUMINA' },
  { code: 15, name: 'AMMONIUM SULPHATE' },
  { code: 97, name: 'ANHYDRITE' },
  { code: 22, name: 'AUSSIE LOGS' },
  { code: 72, name: 'BAGGED CEMENT' },
  { code: 94, name: 'BAGGED RICE' },
  { code: 32, name: 'BARLEY' },
  { code: 74, name: 'BARYTES' },
  { code: 5, name: 'BAUXITE' },
  { code: 103, name: 'BEACH IRON' },
  { code: 30, name: 'BHF' },
  { code: 65, name: 'BIOMASS' },
  { code: 66, name: 'CANOLA' },
  { code: 106, name: 'CANOLA MEAL PELLETS' },
  { code: 82, name: 'CASTOR SEED' },
  { code: 13, name: 'CEMENT' },
  { code: 51, name: 'CHROME ORE' },
  { code: 116, name: 'CLAY' },
  { code: 17, name: 'CLINKER' },
  { code: 2, name: 'COAL' },
  { code: 89, name: 'COAL TAR -PITCH' },
  { code: 81, name: 'COKE' },
  { code: 108, name: 'CONCENTRATES' },
  { code: 48, name: 'CONENTRATES' },
  { code: 112, name: 'COPPER CONCENTRATE' },
  { code: 117, name: 'COOKIE MEAL' },
  { code: 19, name: 'CORN' },
  { code: 101, name: 'CORN+SOYBEAN MEAL' },
  { code: 42, name: 'DAP' },
  { code: 45, name: 'DDGS' },
  { code: 67, name: 'DOLOMITE' },
  { code: 71, name: 'DRI' },
  { code: 91, name: 'FELDSPAR' },
  { code: 110, name: 'FERTILIZERS' },
  { code: 84, name: 'FLUORSPAR' },
  { code: 80, name: 'FLXSEED' },
  { code: 99, name: 'FLY ASH' },
  { code: 69, name: 'GENRAL CARGO' },
  { code: 50, name: 'GYPSUM' },
  { code: 63, name: 'HBI' },
  { code: 61, name: 'HRC' },
  { code: 10, name: 'HSS' },
  { code: 87, name: 'ILMENITE SAND' },
  { code: 9, name: 'IRON ORE' },
  { code: 11, name: 'IRON ORE FINES' },
  { code: 54, name: 'IRON ORE PELLETS' },
  { code: 12, name: 'KIWI LOGS' },
  { code: 107, name: 'KMAG' },
  { code: 18, name: 'LIMESTONE' },
  { code: 26, name: 'LOG' },
  { code: 59, name: 'LUMBER' },
  { code: 55, name: 'LUPINS' },
  { code: 70, name: 'MAGNETITE CONCS' },
  { code: 92, name: 'MAIZE' },
  { code: 40, name: 'MANGANESE ORE' },
  { code: 43, name: 'MAP' },
  { code: 78, name: 'MCP' },
  { code: 77, name: 'MESZ' },
  { code: 49, name: 'MET COAL' },
  { code: 28, name: 'METALLURGICAL COKE' },
  { code: 62, name: 'METCOKE' },
  { code: 38, name: 'MILL SCALE' },
  { code: 39, name: 'MILLED RICE' },
  { code: 34, name: 'MILLSCALE' },
  { code: 104, name: 'MINERALS' },
  { code: 90, name: 'MOP' },
  { code: 33, name: 'NICKEL ORE' },
  { code: 20, name: 'NPK' },
  { code: 56, name: 'OATS' },
  { code: 95, name: 'OLIVINE' },
  { code: 102, name: 'PADDY RICE' },
  { code: 76, name: 'PEAS' },
  { code: 1, name: 'PETCOKE' },
  { code: 100, name: 'PHOSPHATE' },
  { code: 21, name: 'PHOSROCK' },
  { code: 93, name: 'PIG IRON' },
  { code: 64, name: 'PKE' },
  { code: 58, name: 'PKS' },
  { code: 16, name: 'POTASH' },
  { code: 47, name: 'PYRITES' },
  { code: 88, name: 'QUARTZ' },
  { code: 83, name: 'RAPE SEED' },
  { code: 29, name: 'SALT' },
  { code: 4, name: 'SAND' },
  { code: 46, name: 'SBM' },
  { code: 53, name: 'SCRAP' },
  { code: 69, name: 'SEED CAKE' },
  { code: 73, name: 'SINTFD' },
  { code: 68, name: 'SLABS' },
  { code: 31, name: 'SLAG' },
  { code: 114, name: 'SODA ASH' },
  { code: 57, name: 'SOREL FLUX' },
  { code: 25, name: 'SOYA BEAN MEAL' },
  { code: 44, name: 'SOYABEANS' },
  { code: 41, name: 'STEEL COILS' },
  { code: 111, name: 'STEEL SHELLS' },
  { code: 27, name: 'STEEL SLABS' },
  { code: 79, name: 'STEELP' },
  { code: 8, name: 'SUGAR' },
  { code: 14, name: 'SULPHUR' },
  { code: 96, name: 'SUNFLOWER SEEDS' },
  { code: 86, name: 'TALC' },
  { code: 85, name: 'TAPIOCA CHIPS' },
  { code: 109, name: 'TSP' },
  { code: 7, name: 'UREA' },
  { code: 6, name: 'WHEAT' },
  { code: 98, name: 'WOOD CHIPS' },
  { code: 35, name: 'WOOD PELLETS' },
  { code: 60, name: 'WOODPULP' },
  { code: 24, name: 'ZINC CONCENTRATE' },
] as const;
